"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isShoulder = exports.getWidthByType = exports.getHeightByType = exports.getDividerGraphic = exports.default = exports.checkDisabledShoulders = exports.Lane = void 0;
var _interfaces = require("../interfaces");
var React = _interopRequireWildcard(require("react"));
var _resources = require("./resources");
var _constants = require("../constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// libraries

// resources

// constants

var Lane = function Lane(props) {
  var type = props.type,
    state = props.state,
    width = props.width,
    height = props.height;
  var Svg = type && _resources.LANES[type] ? _resources.LANES[type] : _resources.LANES.divider;
  var typeString = type ? _interfaces.EATLaneType[type] : null;
  var adjustedOrientation = "scaleX(1)";

  // flip merge for right exit
  if (typeString !== null && typeString !== void 0 && typeString.includes("Right") && typeString !== null && typeString !== void 0 && typeString.includes("Exit")) adjustedOrientation = "scaleX(-1)";

  // flip right-defaulted icons for analogous lefts, except "Exit"
  if (typeString !== null && typeString !== void 0 && typeString.includes("Left") && !(typeString !== null && typeString !== void 0 && typeString.includes("Exit"))) adjustedOrientation = "scaleX(-1)";
  var color = !state ? "#fff" : state === _interfaces.EATLaneState.Open ? _constants.lane_open : _constants.lane_closed;
  var adjustedWidth = getWidthByType(type);
  var adjustedHeight = getHeightByType(type);
  return /*#__PURE__*/React.createElement(Svg, {
    color: color,
    style: {
      transform: adjustedOrientation
    },
    width: width || adjustedWidth,
    height: height || adjustedHeight
  });
};
exports.Lane = Lane;
var _default = Lane;
exports.default = _default;
var isShoulder = function isShoulder(type) {
  if (type === _interfaces.EATLaneType.SoftShoulder || type === _interfaces.EATLaneType.LeftShoulder || type === _interfaces.EATLaneType.RightShoulder) {
    return true;
  } else return false;
};
exports.isShoulder = isShoulder;
var getWidthByType = function getWidthByType(type) {
  if (!type) return "14px";
  switch (type) {
    case _interfaces.EATLaneType.ThroughLane:
    case _interfaces.EATLaneType.LocalLanes:
      return "37";
    case _interfaces.EATLaneType.LeftMergingLane:
    case _interfaces.EATLaneType.RightMergingLane:
    case _interfaces.EATLaneType.LeftEntranceRamp:
    case _interfaces.EATLaneType.RightEntranceRamp:
    case _interfaces.EATLaneType.LeftExitRamp:
    case _interfaces.EATLaneType.RightExitRamp:
      return "28";
    case _interfaces.EATLaneType.LeftTurningLane:
    case _interfaces.EATLaneType.RightTurningLane:
      return "30";
    default:
      return "14";
  }
};
exports.getWidthByType = getWidthByType;
var getHeightByType = function getHeightByType(type) {
  if (!type) return "100%";
  switch (type) {
    case _interfaces.EATLaneType.ThroughLane:
    case _interfaces.EATLaneType.LocalLanes:
      return "54";
    case _interfaces.EATLaneType.LeftMergingLane:
    case _interfaces.EATLaneType.RightMergingLane:
    case _interfaces.EATLaneType.LeftEntranceRamp:
    case _interfaces.EATLaneType.RightEntranceRamp:
    case _interfaces.EATLaneType.LeftExitRamp:
    case _interfaces.EATLaneType.RightExitRamp:
      return "54";
    case _interfaces.EATLaneType.LeftTurningLane:
    case _interfaces.EATLaneType.RightTurningLane:
      return "54";
    default:
      return "100%";
  }
};
exports.getHeightByType = getHeightByType;
var getDividerGraphic = function getDividerGraphic(lane, nextLane) {
  switch (lane.type) {
    case _interfaces.EATLaneType.LeftShoulder:
    case _interfaces.EATLaneType.SoftShoulder:
    case _interfaces.EATLaneType.RightShoulder:
      return null;
    case _interfaces.EATLaneType.ThroughLane:
    case _interfaces.EATLaneType.LocalLanes:
    case _interfaces.EATLaneType.LeftTurningLane:
    case _interfaces.EATLaneType.RightTurningLane:
    case _interfaces.EATLaneType.LeftMergingLane:
    case _interfaces.EATLaneType.RightMergingLane:
    case _interfaces.EATLaneType.LeftEntranceRamp:
    case _interfaces.EATLaneType.RightEntranceRamp:
    default:
      return !nextLane ? null : nextLane && isShoulder(nextLane.type) ? null : /*#__PURE__*/React.createElement(Lane, {
        type: undefined,
        state: undefined
      });
  }
};
exports.getDividerGraphic = getDividerGraphic;
var checkDisabledShoulders = function checkDisabledShoulders(laneDirection) {
  var leftDisabled = false;
  var rightDisabled = false;
  var lanes = laneDirection.lanes;
  lanes.forEach(function (lane) {
    if (lane.type === _interfaces.EATLaneType.LeftShoulder && lane.state === _interfaces.EATLaneState.Closed) leftDisabled = true;else if (lane.type === _interfaces.EATLaneType.RightShoulder && lane.state === _interfaces.EATLaneState.Closed) rightDisabled = true;
  });
  return [leftDisabled, rightDisabled];
};
exports.checkDisabledShoulders = checkDisabledShoulders;